import img_ssq_logo from "./common/ssq_logo.svg";
import img_logo_ls_header from "./common/logo_ls_header.svg";
import img_lselectric_logo from "./common/lselectric_logo.svg";
import img_main_banner_ssq_white from "./common/main_banner_ssq_white.svg";
import img_loading from "./common/loading.svg";
import img_error_empty from "./common/error_empty.svg";
import img_error_member from "./common/error_member.png";
import img_error_employee from "./common/error_employee.png";
import img_error_login from "./common/error_login.svg";

import img_no_image from "asset/images/common/no_image.svg";
import img_edit_image_btn from "./common/edit_image_btn.svg";
import img_download_icon from "./common/download_icon.svg";
import img_download_icon_no from "./common/download_icon_no.svg";
import img_share_icon from "./common/share_icon.svg";
import img_share_icon_black from "./common/share_icon_black.svg";
import img_checkbox_check from "./common/checkbox_check.svg";
import img_open_checkbox from "./common/open_checkbox.svg";
import img_close_checkbox from "./common/close_checkbox.svg";
import img_close_small_icon from "./common/close_small_icon.svg";
import img_arrow_icon from "./common/arrow_icon.svg";
import img_selected_icon from "./common/selected_icon.svg";
import img_select_arrow from "./common/select_arrow.svg";
import img_select_arrow02 from "./common/select_arrow02.svg";
import img_select_arrow_white_down from "./common/select_arrow_white_down.svg";
import img_select_arrow_white_up from "./common/select_arrow_white_up.svg";
import img_checked_card from "./common/checked_card.svg";
import img_adm_approved from "./common/adm_approved.svg";
import img_adm_not from "./common/adm_not.svg";
import img_adm_reject from "./common/adm_reject.svg";
import img_related_suggest_icon from "./common/related_suggest_icon.svg";
import img_recent_search_icon from "./common/recent_search_icon.svg";
import img_view_more_icon from "./common/view_more_icon.svg";
import img_look_another_url from "./common/look_another_url.svg";
import img_empty_search_result from "./common/empty_search_result.svg";
import img_empty_search_result_back from "./common/error_empty_back.svg";
import img_empty_search_result_back_mobile from "./common/error_empty_back_mobile.svg";
import img_homepage_arrow from "./common/homepage_arrow.svg";
import img_uploading_arrow from "./common/uploading_arrow.gif";

import img_login_kakao from "asset/images/common/login_kakao.svg";
import img_login_google from "asset/images/common/login_google.svg";
import img_login_naver from "asset/images/common/login_naver.svg";
import img_popup_loginfail_icon from "asset/images/common/popup_loginfail_icon.svg";
import img_popup_email_icon from "asset/images/common/popup_email_icon.svg";
import img_popup_password_reset_icon from "asset/images/common/popup_password_reset_icon.svg";
import img_popup_password_reset_email_icon from "asset/images/common/popup_password_reset_email_icon.svg";
import img_back_button from "asset/images/common/back_button.svg";
import img_popup_login from "asset/images/common/popup_login.svg";
import img_popup_logout from "asset/images/common/popup_logout.svg";

import img_new_icon from "images/common/new_icon.svg";
import img_delete_icon from "images/common/delete_icon.svg";
import img_cancel_icon from "images/common/icon_cancel.svg";
import img_save_icon from "images/common/save_icon.svg";
import img_edit_icon from "images/common/edit_icon.svg";
import img_alarm_icon from "images/common/icon_alarm.svg";

import img_search_result_icon from "./common/search_result_icon.svg";
import img_pagelink_icon_gray from "./common/page_link_icon_gray.svg";
import img_pagelink_icon_gray_16 from "./common/page_link_icon_gray_16.svg";
import img_pagelink_icon_white from "./common/page_link_icon_white.svg";

import img_date_picker from "images/common/icon_date_picker.svg";
import img_date_arrow from "images/common/icon_date_arrow.svg";
import icon_box_arrowd from "images/common/icon_box_arrowd.svg";
import icon_box_arrowd_on from "images/common/icon_box_arrowd_on.svg";
import icon_down_pdf from "images/common/icon_down_pdf.svg";
import icon_down_xls from "images/common/icon_down_xls.svg";
import icon_arrow_line_white from "images/common/icon_line_arrow_white.svg";
import icon_file_open from "images/common/icon_open.svg";
import icon_file_save from "images/common/icon_save.svg";
import img_icon_fullscrren from "images/common/full_screen_icon_black.svg";
import {getCdnImageUrlBase} from "conf/gconf";
import tag_search from "images/common/tag_search.svg";
import tag_input from "images/common/tag_input.svg";
import tag_plus from "images/common/tag_plus.svg";
import tag_plus_on from "images/common/tag_plus_on.svg";
import tag_time from "images/common/tag_time.svg";
import input_search from "images/common/input_search.svg";

const img_technical_blog_person = () => getCdnImageUrlBase() + "/community/technicalBlog_person.png";

const CommunityVisualQnaPerson = () => getCdnImageUrlBase() + "/community/community_visual_main.png";
const img_event_Popup_Image = () => getCdnImageUrlBase() + "/event/event_Popup_Image.png";

const img_download_img = () => getCdnImageUrlBase() + "./dashboard/download_img.png";

const img_community_qna = () => getCdnImageUrlBase() + "./dashboard/community_qna.png";
const img_community_blog = () => getCdnImageUrlBase() + "./dashboard/community_blog.png";
const img_community_board = () => getCdnImageUrlBase() + "./dashboard/community_board.png";
const img_community_sample = () => getCdnImageUrlBase() + "./dashboard/visual_sample_main.png";

const img_board_person = () => getCdnImageUrlBase() + "/community/board_person.png";

const img_popup_event = () => getCdnImageUrlBase() + "./dashboard/popup_event.png";
const img_popup_event_en = () => getCdnImageUrlBase() + "./dashboard/popup_event_en.png";

export const SsqImages = {
  common: {
    logo: {
      ssq: () => {
        return img_ssq_logo;
      },
      lsElectric: () => {
        return img_lselectric_logo;
      },

      lsHeader: () => {
        return img_logo_ls_header;
      },
      ssqWhite: () => {
        return img_main_banner_ssq_white;
      }
    },
    loading: () => {
      return img_loading;
    },
    emptyError: () => {
      return img_error_empty;
    },
    memberError: () => {
      return img_error_member;
    },
    employeeError: () => {
      return img_error_employee;
    },
    loginError: () => {
      return img_error_login;
    },

    icon: {
      noImage: () => {
        return img_no_image;
      },
      editImageBtn: () => {
        return img_edit_image_btn;
      },
      downloadImg: () => {
        return img_download_icon;
      },
      nondownloadImg: () => {
        return img_download_icon_no;
      },
      shareImg: () => {
        return img_share_icon;
      },
      shareImgBlack: () => {
        return img_share_icon_black;
      },
      fullScreenIcon: () => {
        return img_icon_fullscrren;
      },
      searchResultImg: () => {
        return img_search_result_icon;
      },
      CheckboxCheck: () => {
        return img_checkbox_check;
      },
      openCheckbox: () => {
        return img_open_checkbox;
      },
      closeCheckbox: () => {
        return img_close_checkbox;
      },
      closeSmallIcon: () => {
        return img_close_small_icon;
      },
      arrowIcon: () => {
        return img_arrow_icon;
      },
      selectedIcon: () => {
        return img_selected_icon;
      },
      select: () => {
        return img_select_arrow;
      },
      select02: () => {
        return img_select_arrow02;
      },
      selectWhiteDown: () => {
        return img_select_arrow_white_down;
      },
      selectWhiteUp: () => {
        return img_select_arrow_white_up;
      },
      checkedCard: () => {
        return img_checked_card;
      },
      admissionapproved: () => {
        return img_adm_approved;
      },
      admissionnot: () => {
        return img_adm_not;
      },
      admissionreject: () => {
        return img_adm_reject;
      },
      relatedSuggestResultIcon: () => {
        return img_related_suggest_icon;
      },
      recentSearchIcon: () => {
        return img_recent_search_icon;
      },
      viewMoreIcon: () => {
        return img_view_more_icon;
      },
      viewDetail: () => {
        return img_look_another_url;
      },
      emptySearchResult: () => {
        return img_empty_search_result;
      },
      emptySearchResultBack: () => {
        return img_empty_search_result_back;
      },
      emptySearchResultBackMobile: () => {
        return img_empty_search_result_back_mobile;
      },
      homepageArrow: () => {
        return img_homepage_arrow;
      },
      uploadingArrow: () => {
        return img_uploading_arrow;
      },
      pagelinkGray: () => {
        return img_pagelink_icon_gray;
      },
      pageLinkGray16: () => {
        return img_pagelink_icon_gray_16;
      },
      pagelinkWhite: () => {
        return img_pagelink_icon_white;
      },
      downPdf: () => {
        return icon_down_pdf;
      },
      downXls: () => {
        return icon_down_xls;
      },

      fileOpen: () => {
        return icon_file_open;
      },

      fileSave: () => {
        return icon_file_save;
      },

      arrowLineWhite: () => {
        return icon_arrow_line_white;
      },
      newMark: () => {
        return img_new_icon;
      },
      deleteIcon: () => {
        return img_delete_icon;
      },
      cancelIcon: () => {
        return img_cancel_icon;
      },
      saveIcon: () => {
        return img_save_icon;
      },
      editIcon: () => {
        return img_edit_icon;
      },
      alarmIcon: () => {
        return img_alarm_icon;
      },
      dateInput: () => {
        return img_date_picker;
      },
      dateArrow: () => {
        return img_date_arrow;
      },
      boxArrowDown: () => {
        return icon_box_arrowd;
      },
      boxArrowDownOn: () => {
        return icon_box_arrowd_on;
      },
      tagSearch: () => {
        return tag_search;
      },
      tagInput: () => {
        return tag_input;
      },
      tagTime: () => {
        return tag_time;
      },
      tagPlus: () => {
        return tag_plus;
      },
      tagPlusOn: () => {
        return tag_plus_on;
      },
      inputSearch: () => {
        return input_search;
      },
    }
  },
  header: {
    popup: {
      loginfail: () => {
        return img_popup_loginfail_icon;
      },
      sendemail: () => {
        return img_popup_email_icon;
      },
      passwordReset: () => {
        return img_popup_password_reset_icon;
      },
      passwordResetEmail: () => {
        return img_popup_password_reset_email_icon;
      }
    },
    icon: {
      backButton: () => {
        return img_back_button;
      },
      login: () => {
        return img_popup_login;
      },
      logout: () => {
        return img_popup_logout;
      },
    },
    sns: {
      kakao: () => {
        return img_login_kakao;
      },
      google: () => {
        return img_login_google;
      },
      naver: () => {
        return img_login_naver;
      }
    },
  },
  event: {
    eventPopupImg: () => {
      return img_event_Popup_Image();
    },

  },

};